import React, { lazy, useMemo } from "react";

/**
 * Hook to retrieve the renderer map for SDM SDUI.
 */
export const useRendererMap = () => {
  return useMemo<Record<string, React.LazyExoticComponent<React.FC<any>>>>(
    () => ({
      galleryScrollerComponent: lazy(() =>
        import("../components/gallery-card-scroller/gallery-card-scroller.component").then(
          ({ GalleryCardScrollerComponent }) => ({
            default: GalleryCardScrollerComponent,
          })
        )
      ),
      bentoCardContainerComponent: lazy(() =>
        import(
          "../components/bento-cards-container/bento-cards-container.component"
        ).then(({ BentoCardsContainerComponent }) => ({
          default: BentoCardsContainerComponent,
        }))
      ),
      productCarouselComponent: lazy(() =>
        import(
          "../components/product-carousel/product-carousel.component"
        ).then(({ ProductCarouselComponent }) => ({
          default: ProductCarouselComponent,
        }))
      ),
      brandSpotlightComponent: lazy(() =>
        import("../components/brand-spotlight/brand-spotlight.component").then(
          ({ BrandSpotlightComponent }) => ({
            default: BrandSpotlightComponent,
          })
        )
      ),
      menuTileCarouselComponent: lazy(() =>
        import(
          "../components/menu-tile-carousel/menu-tile-carousel.component"
        ).then(({ MenuTileCarouselComponent }) => ({
          default: MenuTileCarouselComponent,
        }))
      ),
      headerGroupComponent: lazy(() =>
        import("../components/header-group/header-group.component").then(
          ({ HeaderGroupComponent }) => ({
            default: HeaderGroupComponent,
          })
        )
      ),
      bannerCarouselComponent: lazy(() =>
        import("../components/banner-carousel/banner-carousel.component").then(
          ({ BannerCarouselComponent }) => ({
            default: BannerCarouselComponent,
          })
        )
      ),
      verticalFeatureCardContainerComponent: lazy(() =>
        import(
          "../components/vertical-feature-card/vertical-feature-card.component"
        ).then(({ VerticalFeatureCardComponent }) => ({
          default: VerticalFeatureCardComponent,
        }))
      ),
      provinceListComponent: lazy(() =>
        import(
          "../components/province-selector/province-selector.component"
        ).then(({ ProvinceSelectorComponent }) => ({
          default: ProvinceSelectorComponent,
        }))
      ),
      miniInfoCardContainerComponent: lazy(() =>
        import(
          "../components/mini-info-card-container/mini-info-card-container.component"
        ).then(({ MiniInfoCardContainerComponent }) => ({
          default: MiniInfoCardContainerComponent,
        }))
      ),
      footerContentComponent: lazy(() =>
        import("../components/footer/footer.component").then(
          ({ FooterComponent }) => ({
            default: FooterComponent,
          })
        )
      ),
      /* mediaShoppableDisplayComponent: lazy(() =>
        import(
          "../components/media-shoppable-display-component/media-shoppable-display-component.component"
        ).then(({ MediaShoppableDisplayComponent }) => ({
          default: MediaShoppableDisplayComponent,
        }))
      ), */
      /* mediaIABComponent: lazy(() =>
        import(
          "../components/media-iab-component/media-iab-component.component"
        ).then(({ MediaIabComponent }) => ({
          default: MediaIabComponent,
        }))
      ), */
      fireworkComponent: lazy(() =>
        import("../components/firework/firework.component").then(
          ({ FireworkComponent }) => ({
            default: FireworkComponent,
          })
        )
      ),
    }),
    []
  );
};

export default useRendererMap;

// TODO:  Add mock data, you got it from Notion doc (JSON ReSPONSE)
// TODO: Setup SDM app and test component
